<template src="./Products.html"></template>

<script>
import topMenu from '@/components/brand/components/topMenu';
import PeriodSwitcher from '@/components/brand/products/components/PeriodSwitcher';
import pagination from '@/components/components/pagination';
import brandSelect from '@/components/components/BrandSelect';
import {config} from "@/config";

import {createNamespacedHelpers} from 'vuex';

const {mapGetters, mapActions} = createNamespacedHelpers('brand/products')

export default {
  name: "BrandProducts",
  components: {
    topMenu,
    pagination,
    PeriodSwitcher,
    brandSelect
  },
  data() {
    return {
      brandId: this.$route.params.id,
      showOverlay: 0,
      productFieldsList: [
        {
          key: 'article',
          label: 'Артикул',
          sortable: true
        },
        {
          key: 'productName',
          label: 'Название',
          sortable: true
        },
        {
          key: 'descriptionRu',
          label: 'Описание',
          sortable: true
        },
        {
          key: 'applications',
          label: 'Заявки',
          sortable: true
        },
        {
          key: 'conversion',
          label: 'Конверсия',
          sortable: true
        },
        {
          key: 'parentStatus',
          label: 'Статус родства',
          sortable: true
        },
      ],
      categoryFieldsList: [
        {
          key: 'categoryName',
          label: 'Категория',
          sortable: true
        },
        {
          key: 'applications',
          label: 'Заявки',
          sortable: true
        },
        {
          key: 'conversion',
          label: 'Конверсия',
          sortable: true
        },
        {
          key: 'averageCheck',
          label: 'Средний',
          sortable: true
        },
        {
          key: 'MPR',
          label: 'MPR',
          sortable: true
        },
      ],
      exportUrl: config.apiUrl + '/brand/product/export/',
    }
  },
  methods: {
    ...mapActions([
      'GET_PRODUCTS',
      'GET_CATEGORIES',
    ]),
    brandsChange: function (brand) {
      if (brand == null || (this.CURRENT_BRAND != null && this.CURRENT_BRAND.id == brand.id)) {
        return
      }
      this.brandId = brand.saleId.toString()
      this.$store.commit('brand/semantics/CURRENT_BRAND', brand);
      this.GET_PRODUCTS({id: this.brandId, th: this});
      this.GET_CATEGORIES({id: this.brandId, th: this});
    },
    productSortingChanged: function (ctx) {
      this.$store.commit('brand/products/PRODUCT_SORT', ctx.sortBy);
      this.$store.commit('brand/products/PRODUCT_SORT_DIR', ctx.sortDesc ? 'desc' : 'asc');
      this.GET_PRODUCTS({id: this.brandId, th: this});
    },
    categorySortingChanged: function (ctx) {
      this.$store.commit('brand/products/CATEGORY_SORT', ctx.sortBy);
      this.$store.commit('brand/products/CATEGORY_SORT_DIR', ctx.sortDesc ? 'desc' : 'asc');
      this.GET_CATEGORIES({id: this.brandId, th: this});
    },
    goToPageProduct: function (page) {
      this.$store.commit('brand/products/PRODUCT_CURRENT_PAGE', page);
      this.GET_PRODUCTS({id: this.brandId, th: this});
    },
    goToPageCategory: function (page) {
      this.$store.commit('brand/products/CATEGORY_CURRENT_PAGE', page);
      this.GET_CATEGORIES({id: this.brandId, th: this});
    },
    perPageCategory: function (page) {
      this.$store.commit('brand/products/PAGE_SIZE', page);
      this.$store.commit('brand/products/CATEGORY_CURRENT_PAGE', 1);
      this.GET_CATEGORIES({id: this.brandId, th: this});
    },
    perPageProduct: function (page) {
      this.$store.commit('brand/products/PAGE_SIZE', page);
      this.$store.commit('brand/products/PRODUCT_CURRENT_PAGE', 1);
      this.GET_PRODUCTS({id: this.brandId, th: this});
    },
    goToPeriodProduct: function (periodId) {
      this.$store.commit('brand/products/PRODUCT_CURRENT_PERIOD', periodId);
      this.GET_PRODUCTS({id: this.brandId, th: this});
    },
    goToPeriodCategory: function (periodId) {
      this.$store.commit('brand/products/CATEGORY_CURRENT_PERIOD', periodId);
      this.GET_CATEGORIES({id: this.brandId, th: this});
    },
    initPageSize: function () {
      let winHeight = window.innerHeight;
      winHeight = Math.round((winHeight - 245) / 25);
      this.$store.commit('brand/products/PAGE_SIZE', winHeight);
      console.log(winHeight);
    },
  },
  computed: {
    ...mapGetters([
      'PRODUCT_DATA',
      'PRODUCT_CURRENT_PAGE',
      'PRODUCT_AMOUNT_PAGE',
      'CATEGORY_DATA',
      'CATEGORY_CURRENT_PAGE',
      'CATEGORY_AMOUNT_PAGE',
      'PRODUCT_SORT',
      'PRODUCT_SORT_DIR',
      'CATEGORY_SORT',
      'CATEGORY_SORT_DIR',
      'PRODUCT_CURRENT_PERIOD',
      'CATEGORY_CURRENT_PERIOD',
      'PAGE_SIZE',
      'CATEGORY_COUNT_ROW',
      'PRODUCT_COUNT_ROW',

      'CURRENT_BRAND',
    ]),
  },
  mounted() {
    // this.initPageSize();// default 200
    if (this.PRODUCT_DATA.length == 0) {
      this.GET_PRODUCTS({id: this.brandId, th: this});
    }

    if (this.CATEGORY_DATA.length == 0) {
      this.GET_CATEGORIES({id: this.brandId, th: this});
    }
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('brand') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
  }
}
</script>

<style scoped>
.t-cell {
  height: 23px;
  display: block;
  overflow: hidden;
}

.border-right {
  border-right: solid 1px grey;
}

.description-cell {
  display: inline-block;
  max-width: 360px;
}

.article-cell {
  display: inline-block;
  max-width: 150px;
}
.export-nav {
  float: right;
}
</style>

<style>

</style>